import styled from "styled-components";
import Grid from "components/Grid";

export const StyledGrid = styled(Grid)`
  padding: 1.5rem 1rem 1.5rem 1rem;
`;
